module.exports = __webpack_public_path__ + "img/dw1.b10f859b.png";